import React from 'react';
import { Grid, List, ListItem, Stack, Typography, useMediaQuery } from '@mui/material';
import { MainCard } from '../index';
import { connect } from 'react-redux';
import { openSnackbar } from '../../store/actions/Snackbar';

const MyOrganizationInfoPanel = ({
    activeOrg,
    openSnackbar,
    communityMembers,
    orgProperties
}) => {
    const matchDownMD = useMediaQuery(theme => theme.breakpoints.down('md'));

    const handleCopyToClipboard = async text => {
        await navigator.clipboard.writeText(text);
        openSnackbar({
            open: true,
            message: `Organizations ID copied to clipboard!`,
            variant: 'alert',
            alert: {
                color: 'success',
                variant: 'outlined'
            },
            close: false
        });
    };

    return (
        <MainCard title={activeOrg.org_name || ''} sx={{ textTransform: 'capitalize' }}>
            <List sx={{ py: 0 }}>
                <ListItem divider={!matchDownMD}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                            <Stack spacing={0.5}>
                                <Typography color="secondary">Address</Typography>
                                <Typography>
                                    {activeOrg.address?.address_1 || 'Not provided'}
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                </ListItem>
                <ListItem divider={!matchDownMD}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <Stack spacing={0.5}>
                                <Typography color="secondary">City</Typography>
                                <Typography>
                                    {activeOrg.address?.city || 'Not provided'}
                                </Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Stack spacing={0.5}>
                                <Typography color="secondary">State</Typography>
                                <Typography>
                                    {activeOrg.address?.state || 'Not provided'}
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                </ListItem>

                <ListItem divider={!matchDownMD}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <Stack spacing={0.5}>
                                <Typography color="secondary">Zip</Typography>
                                <Typography>
                                    {activeOrg.address?.zip || 'Not provided'}
                                </Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Stack spacing={0.5}>
                                <Typography color="secondary">Status</Typography>
                                <Typography sx={{ textTransform: 'capitalize' }}>
                                    {activeOrg.status || 'Not provided'}
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                </ListItem>

                <ListItem divider={!matchDownMD}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <Stack spacing={0.5}>
                                <Typography color="secondary">Members</Typography>
                                <Typography>{communityMembers?.length || 0} </Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Stack spacing={0.5}>
                                <Typography color="secondary">Units</Typography>
                                <Typography sx={{ textTransform: 'capitalize' }}>
                                    {orgProperties
                                        ? Object.values(orgProperties).filter(p => p.type !== 'org').length
                                        : 0}
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                </ListItem>

                <ListItem>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Stack spacing={0.5}>
                                <Typography color="secondary">Property ID</Typography>
                                <Typography
                                    sx={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() =>
                                        handleCopyToClipboard(activeOrg.property_id)
                                    }
                                >
                                    {activeOrg.property_id}
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                </ListItem>

                <ListItem>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Stack spacing={0.5}>
                                <Typography color="secondary">Org ID</Typography>
                                <Typography
                                    sx={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() =>
                                        handleCopyToClipboard(activeOrg.org_id)
                                    }
                                >
                                    {activeOrg.org_id}
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                </ListItem>
            </List>
        </MainCard>
    );
};

const mapStateToProps = ({ user, manager, properties }) => {
    const { activeOrg } = user;
    const { communityMembers } = manager;
    const { orgProperties } = properties;

    return {
        activeOrg,
        communityMembers,
        orgProperties
    };
};

export default connect(mapStateToProps, {
    openSnackbar
})(MyOrganizationInfoPanel);
